import { render, staticRenderFns } from "./loadingWindow.template.vue?vue&type=template&id=6afde00c&scoped=true&"
var script = {}
import style0 from "./loadingWindow.template.vue?vue&type=style&index=0&id=6afde00c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afde00c",
  null
  
)

export default component.exports